import { useHistory } from 'react-router'
import { ReauthenticationVariant } from 'shared/types'
import {
  exitSystemAdminMode,
  getReauthenticationSuccessPath,
  ViewerMode,
  viewerModeVar,
} from 'shared/utils'

// Reauthentication ends the system admin mode
export const useRedirectToReauthenticationSuccess = () => {
  const history = useHistory()

  return (variant: ReauthenticationVariant) => {
    const successPath = getReauthenticationSuccessPath(variant)

    if (viewerModeVar() === ViewerMode.SYSTEM_ADMIN) {
      exitSystemAdminMode(successPath)
    } else {
      history.push(successPath)
    }
  }
}
